import { useContext } from "react";

import { BoardContext } from "Boards/BoardContext";

export default function useBoardLocation() {
  const [{ groupURL, groupID }] = useContext(BoardContext);

  const isReportBoard =
    window.location.pathname.split("/")[1] === "reports" &&
    !groupURL &&
    !groupID;

  const isGroupBoard = groupURL && groupID;

  const getLocation = () => {
    if (isReportBoard) return "reports";
    if (isGroupBoard) return "groups";
  };

  const location = getLocation();

  return { location, isReportBoard, isGroupBoard };
}
